export default __webpack_public_path__ + "static/media/Insurance_Image.470bee84.svg";